import React, { useEffect, useMemo } from 'react';
import {
	useQuoteDispatch,
	useQuoteState,
} from '../../../../../stateProviders/QuoteStateProvider';

export const AssemblyPricingDisplay: React.FC<{
	assemblyType: string;
	assemblyMaterials: any;
}> = ({ assemblyType, assemblyMaterials }) => {
	const quoteDispatch = useQuoteDispatch();
	const quoteState = useQuoteState();

	const totalPrice = useMemo(() => {
		if (!assemblyMaterials) return 0;
		return assemblyMaterials.reduce((acc: any, material: any) => {
			return acc + material.qty * material.price;
		}, 0);
	}, [assemblyMaterials]);

	useEffect(() => {
		if (quoteState.materialCost[assemblyType] === totalPrice.toFixed(2)) return;
		quoteDispatch({
			materialCost: {
				...quoteState.materialCost,
				[assemblyType]: totalPrice.toFixed(2),
			},
		});
	}, [totalPrice, assemblyType, quoteState.materialCost[assemblyType]]);

	return (
		<div
			data-testid={`${assemblyType.replace(/\s+/g, '-').toLowerCase()}-section`}
		>
			<h3 className="font-bold text-[18px]">{assemblyType}</h3>
			{assemblyMaterials && (
				<>
					<div className="grid grid-cols-3 border border-[lightgrey]">
						<div className="border-b px-[5px] border-r">Material</div>
						<div className="border-b px-[5px] border-r">Quantity</div>
						<div className="border-b px-[5px]">Total Cost</div>
						{assemblyMaterials?.map((material: any, index: number) => {
							return (
								<React.Fragment key={index}>
									{material?.name ? (
										<div className="border-b px-[5px] border-r text-[12px]">
											{material.name}
										</div>
									) : (
										<div className="text-[12px] border-b px-[5px] border-r text-red-500">
											name missing in assembly
										</div>
									)}
									{material?.qty !== undefined && material?.qty !== null ? (
										<div className="border-b px-[5px] border-r">
											{material?.qty?.toFixed(2)}
										</div>
									) : (
										<div className="border-b px-[5px] border-r text-red-500">
											qty missing in assembly
										</div>
									)}
									{material?.price !== undefined && material?.price !== null ? (
										<div className="border-b px-[5px]">
											${(material.qty * material.price).toFixed(2)}
										</div>
									) : (
										<div className="border-b px-[5px] text-red-500">
											price missing in assembly
										</div>
									)}
								</React.Fragment>
							);
						})}
					</div>
					<p>
						<i className="text-[14px]">
							Total material cost for {assemblyType} assemblies:
						</i>{' '}
						${totalPrice.toFixed(2)}
					</p>
				</>
			)}

			{!assemblyMaterials && (
				<i>Missing information to calculate materials for this assembly</i>
			)}
		</div>
	);
};
